import { TIMER_OPTIONS } from '#/unified-rfqs/ui/grfq/quote-builder/config';

const options = [
  ...TIMER_OPTIONS.map((timer) => ({
    value: timer.value,
    label: timer.name,
  })),
];

// we only have one option for now
const defaultOption = options[0]!;

export default function timerView(selectedTimerValue: string | null) {
  const selectedOption =
    options.find((option) => option.value === selectedTimerValue) ??
    defaultOption;

  return { options, selectedOption };
}
